(ns teamoesterreich.user-mode.to-be-done.info
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [teamoesterreich.store :as store]

    ))



(defn get-it [text]

  (let []

    (do
      [mui/paper
       [:br]
       [:h3 (str "To be done '" text "'")]

       [mui/button
        {:variant "contained"
         :color   "primary"
         :onClick #(swap! store/app-state assoc :site :landing)
         }
        "Zurück"]
       [:br]
       [:br]
       ]

      )))